'use client';

import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';

export const HeaderBannerContainer = ({ children }: { children: React.ReactNode }) => {
  const [emblaRef] = useEmblaCarousel({ loop: true }, [
    Autoplay({ delay: 5000, stopOnMouseEnter: true, stopOnInteraction: false }),
  ]);
  return (
    <div ref={emblaRef} className="pointer-events-auto relative z-40 size-full overflow-hidden">
      <div className="flex size-full">{children}</div>
    </div>
  );
};
